import { render, staticRenderFns } from "./LoanAutoValidationBox.vue?vue&type=template&id=748588db&scoped=true"
import script from "./LoanAutoValidationBox.vue?vue&type=script&lang=js"
export * from "./LoanAutoValidationBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748588db",
  null
  
)

export default component.exports